import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Box,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { LoadingButton } from "@mui/lab";
import styles from "./style";

const ManageLeaveDaysModal = ({
  open,
  setOpen,
  loading,
  getLeaveType,
  manageActionType,
  setManageActionType,
  manageLeaveType,
  setManageLeaveType,
  numberOfDays,
  setNumberOfDays,
  manageNotes,
  setManageNotes,
  handleSave,
  employeeId,
}) => {
  const handleClose = () => {
    setOpen(false);
  };
  
  // Map action type display to API value
  const getActionValue = (displayValue) => {
    const mapping = {
      "Add Leave": "add",
      "Forfeit Leave": "forfeit",
      "Buy Leave": "buy"
    };
    return mapping[displayValue] || "add";
  };
  
  const handleSaveClick = async () => {
    if (!employeeId || !manageLeaveType || !numberOfDays || Number(numberOfDays) <= 0) {
      return;
    }
    
    const action = getActionValue(manageActionType);
    await handleSave(action, employeeId, manageLeaveType, numberOfDays, manageNotes);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      scroll={"paper"}
      aria-labelledby="manage-leave-days-title"
      aria-describedby="manage-leave-days-description"
      sx={styles.modalPaper}
    >
      <Box sx={styles.titleGrid}>
        <DialogTitle id="manage-leave-days-title" sx={styles.title}>
          Manage Leave Days
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={styles.closeIcon}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
      <DialogContent dividers>
        <Box>
          {/* Radio Buttons for Leave Actions */}
          <Box sx={styles.radioGroupContainer}>
            <RadioGroup
              value={manageActionType}
              onChange={(e) => setManageActionType(e.target.value)}
              sx={styles.radioGroup}
            >
              <Box sx={styles.radioButtonsGrid}>
                <FormControlLabel
                  value="Add Leave"
                  control={<Radio sx={styles.radio} />}
                  label="Add Leave"
                  sx={styles.radioLabel}
                />
                <FormControlLabel
                  value="Forfeit Leave"
                  control={<Radio sx={styles.radio} />}
                  label="Forfeit Leave"
                  sx={styles.radioLabel}
                />
                <FormControlLabel
                  value="Buy Leave"
                  control={<Radio sx={styles.radio} />}
                  label="Buy Leave"
                  sx={styles.radioLabel}
                />
              </Box>
            </RadioGroup>
          </Box>

          {/* Leave Type Dropdown */}
          <Box sx={styles.fieldContainer}>
            <InputLabel sx={styles.label}>Leave Type</InputLabel>
            <Select
              value={manageLeaveType}
              onChange={(e) => setManageLeaveType(e.target.value)}
              sx={styles.select}
              displayEmpty
            >
              <MenuItem disabled value="">
                Select Leave Type
              </MenuItem>
              {getLeaveType?.map((item, index) => (
                <MenuItem key={index} sx={styles.menuItem} value={item?._id}>
                  {item?.type}
                </MenuItem>
              ))}
            </Select>
          </Box>

          {/* Number of Days Input */}
          <Box sx={styles.fieldContainer}>
            <InputLabel sx={styles.label}>Number of Days</InputLabel>
            <TextField
              value={numberOfDays}
              onChange={(e) => {
                const value = e.target.value;
                // Only allow positive numbers (must be >= 1)
                if (value === "") {
                  setNumberOfDays(value);
                } else if (/^\d+$/.test(value)) {
                  const numValue = parseInt(value, 10);
                  if (numValue >= 1) {
                    setNumberOfDays(value);
                  }
                }
              }}
              placeholder="e.g. 1"
              sx={styles.textField}
              variant="outlined"
            />
          </Box>

          {/* Notes Textarea */}
          <Box sx={styles.fieldContainer}>
            <InputLabel sx={styles.label}>Notes (optional)</InputLabel>
            <TextField
              value={manageNotes}
              onChange={(e) => setManageNotes(e.target.value)}
              placeholder="Reason or notes"
              multiline
              rows={4}
              sx={styles.textArea}
              variant="outlined"
            />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={styles.actionButtons}>
        <LoadingButton
          loading={loading}
          type="button"
          onClick={handleClose}
          sx={styles.cancelButton}
        >
          Cancel
        </LoadingButton>
        <LoadingButton
          loading={loading}
          type="submit"
          onClick={handleSaveClick}
          disabled={!employeeId || !manageLeaveType || !numberOfDays || Number(numberOfDays) <= 0}
          sx={styles.saveButton}
        >
          Save
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ManageLeaveDaysModal;

